import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { FilterColumnService } from '@shared/services/filter-column/filter-column.service';
import { SharepointLogoutService } from '@shared/services/sharepoint-logout/sharepoint-logout.service';
import moment from 'moment';
import { AfLimitToPipe } from '@shared/filters/af-limit-to/af-limit-to.pipe';
import { ConvertDatePipe } from '../../../shared/filters/convert-date/convert-date.pipe';
import { NgArrayPipesModule } from 'ngx-pipes';
import { AfOrderByPipe } from '@shared/filters/af-order-by/af-order-by.pipe';
import { PaginationControlComponent } from '../../../shared/components/pagination-control/pagination-control.component';
import { TooltipModule } from 'primeng/tooltip';
import { AfTranslateDirective } from '../../../shared/modules/translate/directive/af-translate.directive';
import { FilterBySearchAndOrderComponent } from '@shared/components/filter-by-search-and-order/filter-by-search-and-order.component';
import { ConceptListParentService } from '@shared/components/concept-list/utils/concept-list-parent.service';
import { FilterByDatesAndOrderComponent } from '@shared/components/filter-by-dates-and-order/filter-by-dates-and-order.component';
import { FilterByListAndOrderComponent } from '@shared/components/filter-by-list-and-order/filter-by-list-and-order.component';
import { SpanTooltipComponent } from '@shared/components/span-tooltip/span-tooltip.component';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';

@Component({
  selector: 'concept-list-landing',
  templateUrl: './concept-list-landing.component.html',
  standalone: true,
  imports: [
    FilterBySearchAndOrderComponent,
    FilterByDatesAndOrderComponent,
    FilterByListAndOrderComponent,
    SpanTooltipComponent,
    AfTranslateDirective,
    TooltipModule,
    PaginationControlComponent,
    AfOrderByPipe,
    NgArrayPipesModule,
    ConvertDatePipe,
    AfLimitToPipe,
    NgClass,
    FormsModule,
    AfTranslatePipe
  ]
})
export class ConceptListLandingComponent implements OnChanges, OnInit {
  @Input() list: any = null;
  @Input() showList: any = null;
  @Input() proceduresText: any = null;
  skin: any = this.globalCfg.skin;
  conceptList: any = {
    isLandingLogin: this.route.snapshot.data['isMonitoring'] || this.route.snapshot.data['name'] === 'publicConcept' ? true : false,
    searchText: '',
    order: true,
    filterOrder: 'creationDate',
    titleSearchFilter: '',
    creationDateFromDate: null,
    creationDateToDate: null,
    modificationDateFromDate: null,
    modificationDateToDate: null,
    configPagination: {
      itemsPerPage: 50,
      pageLinkSize: 5,
      currentPage: 1,
      firstElement: 0
    },
    titleFilter: {
      name: this.translate.instant('common.affair'),
      filterOrder: 'title',
    },
    referenceFilter: {
      name: this.translate.instant('common.reference'),
      filterOrder: 'referenceId'
    },
    creationDateQueryFilter: {
      name: this.translate.instant('common.creation'),
      filterOrder: 'creationDate'
    },
    modificationDateQueryFilter: {
      name: this.translate.instant('common.modification'),
      filterOrder: 'modificationDate'
    },
    stepFilter: {
      name: this.translate.instant('concept-list-landing.step-proccess'),
      filterOrder: 'step'
    },
    searchFilters: ['title', 'referenceId'],
    listFilters: ['step'],
    dateFilters: ['creationDate', 'modificationDate'],
    globalSearchableFields: ['title', 'referenceId', 'creationDateFilter', 'modificationDateFilter', 'step']
  }
  constructor(
    private route: ActivatedRoute,
    private context: ContextFactory,
    private globalCfg: GlobalCfgFactory,
    private translate: AfTranslateFactory,
    private loader: LoaderFactory,
    private apiService: ApiServiceService,
    private filterColumnService: FilterColumnService,
    private commonUtilsService: CommonUtilsService,
    private sharepointLogoutService: SharepointLogoutService,
    private conceptListParent: ConceptListParentService
  ) { }

  ngOnInit(): void {
    this.configureEvaluatedConcepts();
  }


  ngOnChanges(): void {
    /* if(this.conceptList.amountList && this.list && this.conceptList.amountList !== this.list.length){
      this.configureEvaluatedConcepts();
    } */
    if (!this.showList && this.list) {
      this.resetFilter();
    }
  }

  configureEvaluatedConcepts(){
    this.list.forEach((concept: any) => {
      concept.referenceId = this.skin === 'icam-red' ? concept.referencia : concept.conceptObjectId.toString();
      concept.creationDateFilter = moment(concept.creationDate).format('DD/MM/YYYY HH:mm');
      concept.modificationDateFilter = moment(concept.modificationDate).format('DD/MM/YYYY HH:mm');
    });
    this.conceptList.amountList = this.list.length;
    this.loader.openLoader('concept-list-charged');
    this.configureFilters(this.list);
    this.filterComponentList();
  }

  configureFilters(data: any) {
    this.conceptList.searchFilters.forEach((text: any) => {
      this.conceptList[text + 'SearchFilter'] = '';
    })
    this.conceptList.listFilters.forEach((filter: any) => {
      this.conceptList[filter + 'List'] = this.filterColumnService.extractList(filter, data);
      this.conceptList[filter + 'ListFilter'] = [];
    })
    this.loader.closeLoader(['concept-list-charged']);
  }

  filterComponentList() {
    let filterList = this.list;
    this.conceptList.searchFilters.forEach((text:any) => {
      let searchFilter : any = this.conceptList[text+'SearchFilter'];
      let searchWord : any = text;
      filterList = this.filterColumnService.filterByWord(searchFilter, filterList, searchWord);
    })
    if(this.conceptList.creationDateFilter){
      filterList = this.filterDates('creationDate', filterList);
    }
    this.getFiltratedColumns(filterList);
  }

  filterDates(type: any, list: any){
    this.conceptList[type+'Filter'] = true;
    let dates ={
      from: this.conceptList[type+'FromDate'],
      to: this.conceptList[type+'ToDate']
    }
    return this.filterColumnService.filterByRangeDates(list, type, dates);
  }

  getFiltratedColumns(filterList: any){
    this.conceptList.listFilters.forEach((filter:any) => {
      let filteredList = this.conceptList[filter+'ListFilter'];
      filterList = this.filterColumnService.filterBycolumn(filterList, filteredList, filter);
    })
    this.conceptList.conceptList = filterList;
    this.conceptList.conceptListFilter = filterList;
  }

  onFilterChange(e: any, type: any = '') {
    switch (e.action) {
      case 'filter':
        this.onListFilterChange(e.newValue, type);
        break;
      case 'search':
        this.onSearchFilterChange(e.newValue, type);
        break;
      case 'calendar':
        this.onCalendarFilterChange(e.newValue, type);
        break;
      case 'order':
        this.onOrderFilterChange(type);
        break;
    }
    if (e.action !== 'order') {
      this.applyAllFilters();
    }
  }

  onListFilterChange(newValue: any, type: any) {
    this.conceptList[type + 'ListFilter'] = this.filterColumnService.configureFilterList(this.conceptList[type + 'ListFilter'], newValue);
  }

  onSearchFilterChange(newValue: any, type: any) {
    this.conceptList[type + 'SearchFilter'] = newValue;
  }

  onCalendarFilterChange(newValue: any, type: any) {
    if (newValue.type === 'cancel') {
      return;
    }
    this.conceptList[type + 'Filter'] = newValue.type === 'apply';
    this.conceptList[type + 'FromDate'] = newValue.from;
    this.conceptList[type + 'ToDate'] = newValue.to;
  }

  onOrderFilterChange(type: string) {
    let that = this.conceptList;
    if (that.filterOrder === type) {
      that.order = !that.order;
    } else {
      that.filterOrder = type;
      that.order = !(type !== 'title');
    }
  }

  applyAllFilters() {
    let that: any = this.conceptList;
    let filterList: any = that.conceptList;
    // Global search filter
    if (that.searchText) {
      filterList = this.commonUtilsService.findByWord(filterList, that.searchText, that.globalSearchableFields);
    }

    // Search filters
    that.searchFilters.forEach((filter: any) => {
      filterList = this.filterColumnService.filterByWord(that[filter + 'SearchFilter'], filterList, filter);
    });

    // List filters
    that.listFilters.forEach((filter: any) => {
      filterList = this.filterColumnService.filterBycolumn(filterList, that[filter + 'ListFilter'], filter);
    });

    // Date filters
    that.dateFilters.forEach((filter: any) => {
      if (!that[filter + 'Filter']) {
        return;
      }
      filterList = this.filterColumnService.filterByRangeDates(filterList, filter, {
        from: that[filter + 'FromDate'],
        to: that[filter + 'ToDate']
      });
    });

    that.conceptListFilter = filterList;
  }

  orderBySearch(e: any, type: any){
    let newValue: any = e.newValue;
    let action: string = e.action;
    if(type){
      switch(action){
        case 'filter':
          this.conceptList[type+'SearchFilter'] = newValue;
          this.filterComponentList();
          break;
        case 'order':
          this.orderDate(type);
          break;
        default:
          break;
      }
    }
  }

  openConceptAction(instance: any) {
    this.conceptListParent.openActionInstance(instance, this, 'query');
  }

  launchActionOption(option:any, item:any){
    this.conceptListParent.LaunchActionOption(option, item, this)
  }

  orderDate(type: any){
    if(this.conceptList.dateFilter === type){
      this.conceptList.order = !this.conceptList.order;
    }else{
      this.conceptList.dateFilter = type;
      if(type === 'title'){
        this.conceptList.order = false;
      }else{
        this.conceptList.order = true;
      }
    }
  }

  changeCalendar(e: any, type: any){
    let dates = e.dates;
    // this.dropdown.close();
    this.conceptList[type+'Filter'] = dates.type === 'cancel'?this.conceptList[type+'Filter']:dates.type === 'apply';
    if(dates.type !== 'cancel'){
      this.conceptList[type+'FromDate'] = dates.from;
      this.conceptList[type+'ToDate'] = dates.to;
      let filterList = this.filterColumnService.filterByRangeDates(this.list, type, dates);
      this.getFiltratedColumns(filterList);
    }
  }

  openConcept(item: any, newTab: boolean=false) {
    this.context.user.password = decodeURIComponent(item.publicUrl.substring(item.publicUrl.indexOf('=')+1));
    this.loginAndGo(item, newTab);
  }

  loginAndGo(item: any, newTab:boolean=false) {
    let queryString = this.route.snapshot.queryParams;
    if (this.skin === 'icam-red' && queryString['sso_token']) {
      let loginContext = {
        sso_token: queryString['sso_token'],
        sso_timestamp: queryString['sso_timestamp'],
        sso_hash: queryString['sso_hash'],
        sso_perfil: queryString['sso_perfil'],
        sso_username: queryString['sso_username'],
        sso_situacion: queryString['sso_situacion'],
        sso_estado: queryString['sso_estado']
      };
      this.context.user.context = loginContext;
    }
    this.apiService.login(this.context.user, this.conceptList.isLandingLogin ? 'public' : 'front')
      .then((data:any)=> {
        this.continueLogin(item, newTab, data);
      }, (errorData:any)=> {}
    );
  }

  continueLogin(item: any, newTab:boolean=false, data: any){
    this.sharepointLogoutService.logout();
    data.user = this.context.user;
    this.context.setLogin(data);
    let openTab: string = newTab?'_blank':'_self';
    // let url = decodeURIComponent(item.publicUrl);
    window.open(item.publicUrl, openTab);
  }

  showTooltip(element:string = ''){
    return this.commonUtilsService.showTooltip(element);
  }

  resetFilter(){
    this.conceptList.creationDateFromDate = null;
    this.conceptList.creationDateToDate = null;
    this.conceptList.creationDateFilter = false;
    this.configureFilters(this.list);
    this.filterComponentList();
  }

  changeCurrentPage(e: any){
    this.conceptList.configPagination.currentPage = e.currentPage;
    this.conceptList.configPagination.firstElement = e.firstElement;
  }

}


